// storybook-check-ignore
import { Text, TextProps } from '@opendoor/bricks-next';

import { markdownToReactElement } from './utils';

type TextTokenProps = Omit<TextProps, 'tag' | 'typography'> & {
  children?: string;
};

export const Eyebrow = ({ children, ...props }: TextTokenProps) => {
  return (
    <Text
      tag="p"
      typography={'$bodySmall'}
      fontWeight="$subheaderSmall"
      display="block"
      color="$borderStateHoverPrimary"
      {...props}
    >
      {children}
    </Text>
  );
};

export const Subhead = ({ children, ...props }: TextTokenProps) => {
  return (
    <Text
      tag="h4"
      display="block"
      typography="$bodyLarge"
      fontWeight="$subheaderSmall"
      color={'$contentPrimary'}
      {...props}
    >
      {children}
    </Text>
  );
};

export const SubheadSmall = ({ children, ...props }: TextTokenProps) => {
  return (
    <Text
      tag="h3"
      typography={'$bodyLarge'}
      $smallerThanLG={{
        typography: '$bodyMedium',
        fontWeight: '$subheaderSmall',
      }}
      fontWeight={'$subheaderSmall'}
      color={'$contentPrimary'}
      display="block"
      {...props}
    >
      {children}
    </Text>
  );
};

interface TitleWithAccentProps extends TextTokenProps {
  title?: string;
  titleAccent?: string;
  titleSize?: any;
  titleColor?: TextProps['color'];
  titleAccentColor?: TextProps['color'];
  breakTitles?: boolean;
}

export const TitleWithAccent = ({
  title,
  titleAccent,
  titleSize,
  titleColor,
  titleAccentColor,
  breakTitles,
  ...props
}: TitleWithAccentProps) => {
  const typography = {
    typography:
      titleSize === 'Large' ? '$headerLarge' : ('$headerMedium' as TextProps['typography']),
    $largerThanSM: {
      typography: titleSize === 'Large' ? '$displaySmall' : '$headerMedium',
    } as TextProps['$largerThanSM'],
    $largerThanMD: {
      typography: titleSize === 'Large' ? '$displaySmall' : '$headerLarge',
    } as TextProps['$largerThanMD'],
  };

  return (
    <Text
      tag="h2"
      {...typography}
      display="block"
      maxWidth={'16ch' as unknown as number}
      color={titleColor || '$contentPrimary'}
      mb={'$8x'}
      {...props}
      whiteSpace="normal"
    >
      {markdownToReactElement(title || '')}
      {breakTitles && <br />}
      {titleAccent && (
        <Text
          tag="span"
          {...typography}
          color={titleAccentColor || '$contentTertiary'}
          {...props}
          whiteSpace="normal"
        >
          {' '}
          {markdownToReactElement(titleAccent)}
        </Text>
      )}
    </Text>
  );
};

export const Desc = ({ children, ...props }: TextTokenProps) => {
  if (!children) return null;

  return (
    <Text tag="p" color="$contentPrimary" typography="$bodyLarge" display="block" {...props}>
      {markdownToReactElement(children as string)}
    </Text>
  );
};
